import services from './services'
import Tree from "Tree"
export default{
    mixins:[services],
    components:{Tree},
    props:{
        value:{
            type:Boolean,
            require:true,
            default:false
        },
    },
    created(){
        this.visible=this.value;
        this.getEmployee();
    },
    watch:{
        value(val){
          this.visible=val;
        },
        visible(val){
            this.$emit("input",val);
        },
    },
    data(){
        return{
          visible:false,
          TreeDataList:[],
          ManageData:[],
          ParentData:{
            d_id:"",
            d_name:"",
            employeeId:"",
            employeeName:"",
          },
          queryEmployName:"",
        }
    },
    computed:{
        sysSid:function(){
            return this.$store.state.sysSid;
        },
        sysSession:function(){
            return this.$store.state.sysSession;
        },
    },
    methods:{
        handleNodeClick(value){
          this.getManager(value)
        },
        handleIconClick(){
            this.getManager(this.queryEmployName,"search")
        },
        sure(){
            this.$emit("input",false);
            this.$emit("sure",this.ParentData);
        },
        ActionManageClose(){
           this.queryEmployName="";
           this.$emit("input",false);
        },
        ActionEmp(val){
               this.ParentData.d_id=val.d_id;
               this.ParentData.d_name=val.d_name;
               this.ParentData.employeeName=val.name;
               this.ParentData.employeeId=val.ID;
        }
    },
    
}


// WEBPACK FOOTER //
// ./src/common/components/employee/vm.js